export default __webpack_public_path__ + "static/media/visit_documents.0a9a45b2.svg";